import { useEffect } from "react";
import { Link } from "react-router-dom";

const SCOPE = [
  { icon: "ri-movie-2-line", title: "电影资料", desc: "类型、地区、年份、主创与剧情简介" },
  { icon: "ri-tv-line", title: "电视剧资料", desc: "集数、首播时间、主创与剧情简介" },
  { icon: "ri-search-line", title: "资源检索", desc: "按名称模糊搜索电影、电视剧与资讯" },
  { icon: "ri-bookmark-line", title: "本地收藏", desc: "收藏喜欢的作品，刷新后仍然保留" },
];

const FEATURES = [
  { icon: "ri-filter-3-line", title: "多维筛选", desc: "按类型、地区、年份与剧集数快速筛选" },
  { icon: "ri-sort-desc", title: "灵活排序", desc: "支持按最新、最热门与评分排序浏览" },
  { icon: "ri-magic-line", title: "同类推荐", desc: "基于类型与标签推荐相似影视作品" },
  { icon: "ri-newspaper-line", title: "影视资讯", desc: "影视新闻、行业动态与影片预告" },
];

export default function About() {
  useEffect(() => {
    document.title = "关于白虎 - 白虎影视平台";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "了解白虎影视平台的定位、内容范围、联系方式与版权声明。白虎致力于为影视爱好者提供全面、清晰的影视内容展示与检索体验。"
      );
    }
  }, []);

  return (
    <div className="animate-fadeIn">
      <section className="border-b border-background-200 bg-primary-500">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <nav
            className="flex items-center gap-1.5 text-sm text-background-200"
            aria-label="面包屑"
          >
            <Link to="/" className="transition-colors hover:text-accent-300">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-50">关于白虎</span>
          </nav>
          <h1 className="mt-6 max-w-3xl text-3xl font-black leading-tight text-background-50 md:text-5xl">
            关于白虎影视平台
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            白虎是一个面向广大影视爱好者的综合影视内容展示平台。我们致力于打造权威、全面的影视资料库，
            通过丰富的分类与详尽的介绍，帮助每一位观众高效筛选、浏览并收藏心仪的影视作品。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">网站定位</h2>
        <p className="mt-4 max-w-4xl text-sm leading-loose text-foreground-700 md:text-base">
          白虎面向广大影视爱好者与普通观众，聚焦于电影和电视剧的资源检索、分类浏览与内容介绍。
          用户的核心需求集中在快速找到热门及最新影视作品、了解剧情与主创信息，并在观影前获得可靠的参考。
          我们不提供在线播放、下载、会员或支付服务，搜索与收藏均为前端演示功能，旨在展示完整的产品体验。
        </p>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {SCOPE.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-lg text-accent-400">
                <i className={item.icon}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">内容范围与特色</h2>
          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {FEATURES.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-lg text-background-50">
                  <i className={item.icon}></i>
                </span>
                <h3 className="mt-4 text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-200 text-base text-secondary-900">
                <i className="ri-customer-service-2-line"></i>
              </span>
              联系方式与反馈渠道
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              如果你对平台内容有任何建议、发现资料有误，或希望补充新的影视条目，欢迎通过以下方式与我们联系。
              我们会在收到反馈后尽快核实处理。
            </p>
            <ul className="mt-5 space-y-3 text-sm text-foreground-800">
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-lg text-accent-600"></i>
                反馈邮箱：feedback@baihu-demo.com
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-time-line text-lg text-accent-600"></i>
                服务时间：周一至周五 09:00 - 18:00
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-map-pin-line text-lg text-accent-600"></i>
                内容合作：welcome@baihu-demo.com
              </li>
            </ul>
            <p className="mt-4 text-xs text-foreground-400">
              以上联系方式为演示信息，实际使用时可替换为真实渠道。
            </p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-200 text-base text-secondary-900">
                <i className="ri-shield-check-line"></i>
              </span>
              声明与版权信息
            </h2>
            <ul className="mt-4 space-y-4 text-sm leading-relaxed text-foreground-600">
              <li className="flex gap-2.5">
                <i className="ri-checkbox-circle-line mt-0.5 text-base text-accent-600"></i>
                <span>本站所有影视资料、海报与资讯均为演示内容，仅用于产品功能展示，不代表真实数据。</span>
              </li>
              <li className="flex gap-2.5">
                <i className="ri-checkbox-circle-line mt-0.5 text-base text-accent-600"></i>
                <span>本站不提供任何影视作品的在线播放、下载服务，不涉及会员与支付功能。</span>
              </li>
              <li className="flex gap-2.5">
                <i className="ri-checkbox-circle-line mt-0.5 text-base text-accent-600"></i>
                <span>搜索、收藏与筛选结果均为前端本地演示，不会上传或存储你的个人信息。</span>
              </li>
              <li className="flex gap-2.5">
                <i className="ri-checkbox-circle-line mt-0.5 text-base text-accent-600"></i>
                <span>© 2026 白虎影视平台。未经许可，请勿将本站内容用于商业用途。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link
            to="/movies"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-movie-2-line"></i>
            浏览电影频道
          </Link>
          <Link
            to="/tvseries"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-600"
          >
            <i className="ri-tv-line"></i>
            浏览电视剧频道
          </Link>
        </div>
      </section>
    </div>
  );
}